import Vue from "vue";
import Vuex from "vuex";

import appMutations from "./store/mutations";
import appActions from "./store/actions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    subList: [],
    page: 1,
    total: 0,
    totalActive: 0,
    sortby: "all",
    sortdir: "up",
    modalShow: false,
    notificationShow: false,
    notificationText: "",
    modalSub: {},
    refList: [],
    newRef: {
      open: false
    },
    currentRef: {},
    cupons: [],
    cuponForm: {
      open: false,
      mode: "",
      cupon: "",
      free_days: "",
      qty: "",
      valid_until: "",
      type: 1,
      company: ""
    },
    cuponUsers: [],
    stats: {
      subs: [],
      loading: false
    }
  },
  mutations: appMutations,
  actions: appActions,
  getters: {
    getRefById(state) {
      return id => {
        return state.refList.find(ref => ref.id === id);
      };
    },

    getCuponById(state) {
      return id => {
        return state.cupons.find(cupon => cupon.id === id);
      };
    }
  }
});
